import { useMutation } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import { getAssessorListQuestionnairesQueryKey } from '@/api/assessor-questionnaire.hook'
import { getGetCompanyQueryKey } from '@/api/company.hook'
import { createQuestionnaire as createQuestionnaireV2 } from '@/gen/questionnaire/v2/questionnaire-QuestionnaireService_connectquery'

export const useCreateInfoQuestionnaire = () => {
  const queryClient = useQueryClient()

  return useMutation(createQuestionnaireV2, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getAssessorListQuestionnairesQueryKey() })
      queryClient.invalidateQueries({ queryKey: getGetCompanyQueryKey() })
    },
  })
}
